import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

const Container = styled.div`
  .wrapper {
    position: relative;
  }

  .overlay {
    position: absolute;
    bottom: 100%;
    left: 0;
    right: 0;
    background-color: #00000080;
    overflow: hidden;
    width: 100%;
    height: 0;
    transition: 0.5s ease;
    border-radius: 8px;
  }

  .wrapper:hover {
    .overlay {
      bottom: 0;
      height: 100%;
    }
  }

  .text {
    color: white;
    font-size: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }
  .button {
    border-radius: 20px;
    margin-top: 20px;
    transition: 0.5s ease;
  }
`;

const Image = styled.img`
  display: block;
  width: 100%;
  height: 260px;
  object-fit: cover;
  border-radius: 8px;
`;

const CategoryItem = ({ item, styles }) => {
  return (
    <>
      <Container className="column" style={styles} key={item.id}>
        <div className="wrapper">
          <Image
            src={item.node.image.asset.fluid.src}
            alt="Avatar"
            className="image"
          />

          <div className="overlay">
            <div className="text has-text-white is-uppercase">
              {' '}
              {item.node.title}
              <Link
                to={item.node.slug.current}
                className="button is-primary has-text-weight-normal is-uppercase"
                type="button"
              >
                shop now
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default CategoryItem;
